import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { UpdateOtaChannelFormData } from "../schema/UpdateOtaChannelSchema";
import { OtaChannelResponseSchema } from "../response/UpdateOtaChannelResponse";

export const useUpdateOta = () => {
    return useMutation({
        mutationFn: async (values: {
            agentId: string;
            formData: UpdateOtaChannelFormData;
        }) => privateApi.put(`/v3/ota/${values.agentId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = OtaChannelResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid update ota data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update ota', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid ota data format");
            } else {
                console.error('Failed to update ota', error);
                throw error;
            }
        },
    });
};